import { render, staticRenderFns } from "./CustomQuestions.vue?vue&type=template&id=95cfc96e&scoped=true"
import script from "./CustomQuestions.vue?vue&type=script&lang=js"
export * from "./CustomQuestions.vue?vue&type=script&lang=js"
import style0 from "./CustomQuestions.vue?vue&type=style&index=0&id=95cfc96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cfc96e",
  null
  
)

export default component.exports